import { Link } from "react-router-dom";

// Storefront mega-menu: a column per department, each listing its live
// in-stock categories with their subcategories. Data comes from GET /nav/shop.
export default function ShopMegaMenu({ nav, onEnter, onLeave, onNavigate }) {
  if (!nav?.length) return null;
  const cols = Math.min(nav.length, 4);
  return (
    <div
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      className="absolute left-0 right-0 top-full bg-background border-b border-foreground shadow-[0_30px_60px_-30px_hsl(var(--foreground)/0.45)]"
    >
      <div
        className="max-w-[1600px] mx-auto px-6 md:px-12 py-9 grid gap-10"
        style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}
      >
        {nav.map((dep) => (
          <div key={dep.department}>
            <Link
              to={`/shop?department=${encodeURIComponent(dep.department)}`}
              onClick={onNavigate}
              className="font-serif text-2xl tracking-tighter hover:text-[hsl(var(--accent))]"
            >
              {dep.department}
            </Link>
            <div className="mt-2 h-px bg-foreground/15" />
            <div className="mt-4 space-y-4">
              {dep.categories.length === 0 && (
                <p className="text-sm text-muted-foreground">Coming soon</p>
              )}
              {dep.categories.map((cat) => (
                <div key={cat.id}>
                  <Link
                    to={`/shop?department=${encodeURIComponent(dep.department)}&category_id=${cat.id}`}
                    onClick={onNavigate}
                    className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground"
                  >
                    {cat.name}
                  </Link>
                  {cat.subcategories.length > 0 && (
                    <ul className="mt-2 space-y-1.5">
                      {cat.subcategories.map((s) => (
                        <li key={s.id}>
                          <Link
                            to={`/shop?department=${encodeURIComponent(dep.department)}&subcategory_id=${s.id}`}
                            onClick={onNavigate}
                            className="text-sm hover:text-[hsl(var(--accent))]"
                          >
                            {s.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pb-6">
        <Link
          to="/shop"
          onClick={onNavigate}
          className="font-mono text-[11px] uppercase tracking-[0.18em] border-b border-foreground/40 pb-0.5 hover:text-[hsl(var(--accent))] hover:border-[hsl(var(--accent))]"
        >
          View all products →
        </Link>
      </div>
    </div>
  );
}
